var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIdeaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-idea"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.4995 8.8254C5.51055 6.68428 5.97363 4.18125 7.67013 2.49802C9.36663 0.81478 11.9573 0.287956 14.219 1.16626C16.4807 2.04456 17.9612 4.15235 17.9615 6.49452",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M6.14297 10.8482C4.27146 9.93622 2.55438 8.75777 1.04997 7.35283C0.865005 7.18406 0.757819 6.95142 0.752187 6.7065C0.746555 6.46158 0.842943 6.22463 1.01997 6.04819C2.55397 4.48915 6.76297 0.74707 11.764 0.74707C15.964 0.74707 20.956 4.49107 22.852 6.04339C23.0641 6.21447 23.1906 6.46397 23.2 6.72979",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M15.7002 7.81738V9.3601",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M8.2002 15.1201H9.8072",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M23.1998 15.1201H21.5928",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    d: "M9.51367 10.416L10.8787 11.7255",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    d: "M21.8855 10.416L20.5205 11.7255",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4498 15.1202C19.4518 13.3217 18.0708 11.7977 16.2152 11.5506C14.3595 11.3034 12.5986 12.4088 12.0904 14.1399C11.5822 15.8709 12.4828 17.6965 14.1998 18.4159V20.1602H17.1998V18.4159C18.5658 17.8446 19.4493 16.5505 19.4498 15.1202V15.1202Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9",
    d: "M14.2002 22.3203H17.2002",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIdeaIcon);
export default __webpack_public_path__ + "static/media/eyeIdeaIcon.3ec84880b2d5816897655032e6fec911.svg";
export { ForwardRef as ReactComponent };